import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { HelperService } from 'src/app/services/helper.service';
import { ModalController,NavController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
@Component({
  selector: 'app-spot-gift-card',
  templateUrl: './spot-gift-card.page.html',
  styleUrls: ['./spot-gift-card.page.scss'],
})
export class SpotGiftCardPage implements OnInit {
  userId: any;
  giftCards: any = [];
  isLoading: boolean;
  noDataImage : any;
  check: any=0;

  constructor(private toastService: ToastService, private routerActivate: ActivatedRoute,private router : Router, private toast: HelperService,private service : StoreService,
    private navController:NavController) { }

  ngOnInit() {
      this.userId = localStorage.getItem('userId');
      this.getGiftCards();
    this.giftCards=[];
  }
  getGiftCards(){
    this.isLoading = true;
   this.service.getGiftCard() .subscribe((result: any) => {
     this.isLoading = false;
     this.giftCards=result;
     
     console.log("get Gift Card",result)
     this.toastService.presentToast(result.msg)
     if (this.giftCards.length > 0) {
      this.check = 0;
    } else {
      this.check = 1;
      console.log("hekkkk")
    }
     }, (error: any) => {    
  }); 
  }

  onClick(productItem: any) {
    let qty = 1;
    // console.log("product item object clickable product",productItem);
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { backPageFlagInfo: "gift" } } };
    this.router.navigate(['/product-detail'], navigationParams);
  }
  // }
  // goBack(){
  //   this.navController.pop();
  // }

  // notifications(){
  //   this.router.navigate(['/wishlist'])
  // }
  goBack() {
    this.navController.back();
  }

  notifications() {
    this.router.navigate(['/wishlist'])
  }
  
}
